import { useEffect, useRef } from "react";

interface Props {
  userRoles?: string[];
  matchUrlHome?: boolean;
  matchUrlCleanSystem?: boolean;
}

const VersionReloadWatcher: React.FC<Props> = ({
  userRoles,
  matchUrlHome,
  matchUrlCleanSystem,
}) => {
  const intervalReloadRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    let currentVersion = window.__env?.REACT_APP_VERSION;
    let interval: NodeJS.Timeout | null = null;

    const startReloadInterval = () => {
      if (intervalReloadRef.current) return;
      // 5秒ごとにリロード条件を満たすかチェックし、満たせばリロード
      intervalReloadRef.current = setInterval(() => {
        let isReload = false;
        if (matchUrlHome) {
          isReload = true;
        } else if (matchUrlCleanSystem) {
          const elementButton = document.getElementById("use-clean-system-button");
          if (elementButton) {
            isReload = true;
          }
        }
        if (isReload) {
          window.location.reload();
        }
      }, 5000);
    };

    // wash_bottleロールかつホームまたはクリーンシステム画面の場合のみバージョン監視を行う
    if (
      userRoles?.includes("wash_bottle") &&
      (matchUrlHome || matchUrlCleanSystem)
    ) {
      // env-config.jsを読み込んでバージョン変更を定期的にチェックする
      interval = setInterval(async () => {
        try {
          const script = document.createElement("script");
          script.src = `${window.location.origin}/env-config.js?ts=${Date.now()}`;
          script.onload = () => {
            const newVersion = window.__env?.REACT_APP_VERSION;
            if (newVersion && newVersion !== currentVersion) {
              console.log(
                `Version changed: ${currentVersion} → ${newVersion}`
              );
              startReloadInterval();
            }
          };
          document.body.appendChild(script);
        } catch (err) {
          console.error("Version reload check failed", err);
        }
      }, 30000);
    }

    return () => {
      if (interval) clearInterval(interval);
      if (intervalReloadRef.current) clearInterval(intervalReloadRef.current);
      intervalReloadRef.current = null;
    };
  }, [userRoles, matchUrlHome, matchUrlCleanSystem]);

  return null;
};

export default VersionReloadWatcher;